// translationUtils.js

import EnJson from "./locales/en/en.json";
import FrJson from "./locales/fr/fr.json";
import DeJson from "./locales/de/de.json";

const translations = {
  "en-lu": EnJson,
  "fr-lu": FrJson,
  "de-lu": DeJson,
};

export function getTranslation(locale, prefix = "") {
  const prefixKeys = prefix ? prefix.split(".") : [];
  let translation = translations["en-lu"];
  if (translations[locale]) {
    translation = translations[locale];
  }

  // drill down to prefix if provided
  for (const j of prefixKeys) {
    if (translation && translation[j]) {
      translation = translation[j];
    }
  }

  // return a function that accepts key + props
  return (key, props = {}) => {
    const keys = key.split(".");
    let currentTranslation = translation;

    for (const k of keys) {
      if (currentTranslation && currentTranslation[k] !== undefined) {
        currentTranslation = currentTranslation[k];
      } else {
        return prefix ? `${prefix}.${key}` : key;
      }
    }

    if (typeof currentTranslation === "string") {
      // replace {placeholders} with props values
      return currentTranslation.replace(/\{(\w+)\}/g, (_, match) => {
        return props[match] !== undefined ? props[match] : `{${match}}`;
      });
    }

    return currentTranslation;
  };
}

export function getTranslationKeys(language, prefix = "") {
  const t = getTranslation(language, prefix);
  // return all keys inside the namespace/prefix
  const translation = translations[language] || translations["en-lu"];
  const prefixKeys = prefix ? prefix.split(".") : [];
  let current = translation;
  for (const j of prefixKeys) {
    if (current && current[j]) {
      current = current[j];
    }
  }
  return Object.keys(current);
}
